import React, { useState, useEffect, useContext } from 'react';
import ReactDOM from "react-dom";
import $ from 'jquery';
import { Pagination, Select, DatePicker } from 'antd';
import moment from 'moment';
import Moment from 'react-moment';
import bootbox from 'bootbox';
import CommonUtils from '../util/CommonUtils';
import ShareVideoEmailTemplate from './email-templates/share-video-template';
import Toastr from 'toastr';
import { Context } from '../../src/views/app';

const { RangePicker } = DatePicker;
const { Option } = Select;

function VideosLibrary(props) {
    let appContex = useContext(Context);
    let user = appContex.user;

    let zones = [...user.zones];
    const timezone = user.site_selected.site_iana_timezone;
    let site_id = user.site_selected.site_id;
    let startDate = props.date ? moment(props.date, 'YYYY-MM-DD').add(-6, 'days').startOf('day') : moment().add(-6, 'days');
    let endDate = props.date ? moment(props.date, 'YYYY-MM-DD').startOf('day') : moment();

    const [timeLapseVideosEnabled, setTimeLapseVideosEnabled] = useState(true);
    const [liveVideosEnabled, setLiveVideosEnabled] = useState(true);
    const [videos, setVideos] = useState(true);
    const [pagination, setPagination] = useState({ page: 1, pageSize: 6 });
    const [start_date, setStartDate] = useState(startDate.format('YYYY-MM-DD'));
    const [end_date, setEndDate] = useState(endDate.format('YYYY-MM-DD'));
    const [locationId, setLocationId] = useState('');
    const paginationDefaults = { page: 1, pageSize: 6 };
    const date_defaults = [startDate, endDate];

    useEffect(() => {
        if (locationId && start_date && end_date) {
            getMyTimelapseVideos();
        }
    }, [liveVideosEnabled]);

    useEffect(() => {
        if (locationId && start_date && end_date) {
            getMyTimelapseVideos();
        }
    }, [timeLapseVideosEnabled]);

    const getMyTimelapseVideos = (page = pagination.page, pageSize = pagination.pageSize) => {

        if (!(timeLapseVideosEnabled || liveVideosEnabled))
            return;

        $('.video-container, #submitBtn').addClass('hide');
        $('.loading').removeClass('hide');
        console.log(timeLapseVideosEnabled, liveVideosEnabled)
        let request = {
            user_login: user.user_login,
            user_token: user.user_token,
            app_name: 'SITESUPT',
            form_input: {
                operation: timeLapseVideosEnabled ? liveVideosEnabled ? 'live-and-timelapse-videos' : 'timelapse-videos' : 'live-videos',
                site_id: user.site_selected.site_id,
                location_id: locationId,
                from_date: start_date,
                to_date: end_date,
                offset: (page - 1) * pageSize,
                fetch_size: pageSize,
                timezone: timezone
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/videos-history',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(request),
                dataType: "json"
            }
        ).then((res) => {
            if (res && res.status.code === 200) {
                setPagination({ page: page, pageSize: pageSize, total_found: res.data.total_found, total_returned: res.data.total_returned });
                setVideos(res.data.records);
                // this.setState({ pagination: { page: page, pageSize: pageSize, total_found: res.data.total_found, total_returned: res.data.total_returned }, videos: res.data.records, loading: false });
            }
            $('.video-container, #submitBtn').removeClass('hide');
            $('.loading').addClass('hide');
        }, (err) => {
            $('.video-container, #submitBtn').removeClass('hide');
            $('.loading').addClass('hide');
        });

    }

    const disabledDate = (current) => {
        // Can not select days after today
        return current && current > moment().endOf('day');
    }

    const handleInput = (val, field) => {
        switch (field) {
            case 'location_id':
                setPagination(paginationDefaults);
                setVideos(null);
                setLocationId(val);
                break;
            case 'start_end_dates':
                if (val) {
                    setPagination(paginationDefaults);
                    setVideos(null);
                    setStartDate(val[0].format('YYYY-MM-DD'));
                    setEndDate(val[1].format('YYYY-MM-DD'));
                } else {
                    setPagination(paginationDefaults);
                    setVideos(null);
                    setStartDate(null);
                    setEndDate(null);
                }
                break;

            case 'liveVideosEnabled':
                setPagination(paginationDefaults);
                setVideos(null);
                setLiveVideosEnabled(!liveVideosEnabled);
                break;

            case 'timeLapseVideosEnabled':
                setPagination(paginationDefaults);
                setVideos(null);
                setTimeLapseVideosEnabled(!timeLapseVideosEnabled);
                break;

            case 'pagination':
                getMyTimelapseVideos(val[0], val[1]);
                break;

            default:
                break;
        }
    }

    const shareVideo = (v) => {
        bootbox.prompt({
            closeButton: false,
            inputType: 'textarea',
            title: 'Share Video',
            message: 'Please enter semicolon(;) separated email ids to share video', callback: (email_ids) => {
                if (email_ids) {
                    let email_validation = CommonUtils.validateCommaSeparatedEmails(email_ids);

                    if (email_validation.found === 0) {
                        Toastr.error("No email ids found to share the video.");
                        return false;
                    }

                    if (email_validation.valid.length === 0 || email_validation.invalid.length > 0) {
                        Toastr.error("Invalid Email Addresses found. <br />Please correct and try again ! <br />" + email_validation.invalid.join('<br />'));
                        return false;
                    }

                    let obscure_site_id = site_id.substring(4, 8) +
                        site_id.substring(0, 4) +
                        site_id.substring(8);
                    let video_perm_link = v.video_type === 'Recorded Live Video' ?
                        v.signed_url :
                        'https://www.sitesuptondemand.com/' + obscure_site_id + '/timelaps_' + v.request_id + '.mp4';

                    let container = document.createElement('div');
                    let location = user.zones.filter((l) => l.location_id === locationId);
                    ReactDOM.render(
                        <ShareVideoEmailTemplate
                            location_name={location[0].location_name}
                            timestamp={moment.tz(v.sec_timestamp * 1000, timezone).format('MMM DD, YYYY HH:mm')}
                            video_url={video_perm_link}
                            user_name={user.user_name}>
                        </ShareVideoEmailTemplate>, container);

                    CommonUtils.sendEmail({
                        user_login: user.user_login,
                        user_token: user.user_token,
                        site_id: user.site_selected.site_id,
                        location_id: locationId,
                        video_url: video_perm_link,
                        start_time: v.sec_timestamp,
                        end_time: v.sec_timestamp + (v.video_type === 'Recorded Live Video' ? 500 : v.duration),
                        share_email: email_validation.valid.join(';'),
                        video_type: v.video_type === 'Recorded Live Video' ? 'live_clip' : 'timelapse'
                    }).then((result) => {
                        Toastr.success("Video shared successfully !!");
                    }, (error) => {
                        Toastr.success("Failed to share the video. Please try again ...");
                        return false;
                    });
                }

            }
        });
    }

    let videos_found = videos && videos.length > 0;
    const enableSubmit = locationId && start_date && end_date && (timeLapseVideosEnabled || liveVideosEnabled)

    return (
        <React.Fragment>
            <div className="page-container">
                <div className="row mb-2">
                    <div className="col-md-12 text-primary">Select Zone, Date range, Video Type(s) to retrieve videos.</div>
                </div>
                <div className="row">
                    <div className="col-md-7">
                        <div className="row">
                            <div className="col-md-4 col-12">
                                <Select
                                    className="mr-1"
                                    onChange={(obj) => handleInput(obj, 'location_id')}
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder="Select Zone"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                    }>
                                    {zones.map((z, i) => (<Option key={i} value={z.location_id}>{z.location_name}</Option>))}
                                </Select>
                            </div>
                            <div className="col-md-8 col-12">
                                <RangePicker disabledDate={disabledDate} defaultValue={date_defaults} onChange={(obj) => handleInput(obj, 'start_end_dates')} />
                                <button id="submitBtn" disabled={!enableSubmit} className="btn btn-sm btn-primary ml-1" onClick={() => getMyTimelapseVideos()}>Submit</button>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12 mt-1 col-12">
                                <span className="mr-4">Time-lapse <i className={timeLapseVideosEnabled ? "fa fa-lg text-success cursor-pointer fa-toggle-on" : "fa fa-lg text-success cursor-pointer fa-toggle-off"} onClick={() => handleInput(null, 'timeLapseVideosEnabled')}></i></span>
                                <span>Recorded Live Videos <i className={liveVideosEnabled ? "fa fa-lg text-success cursor-pointer fa-toggle-on" : "fa fa-lg text-success cursor-pointer fa-toggle-off"} onClick={() => handleInput(null, 'liveVideosEnabled')}></i></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 text-right mt-md-0 mt-3">
                        {videos_found && <Pagination showLessItems={true} showSizeChanger={false} onChange={(page, pageSize) => handleInput([page, pageSize], 'pagination')} defaultPageSize={pagination.pageSize} defaultCurrent={pagination.page} total={pagination.total_found} />}
                    </div>
                </div>

                <div className="border-rounded p-2 mt-4 loading bg-primary-light hide"><i className="fa fa-lg fa-spin fa-lg fa-circle-notch mr-2"></i>Fetching Videos ...</div>
                <div className="row video-container">
                    {videos_found && videos.map((video, i) => (
                        <div className="col-md-3 mt-3" key={i}>
                            <div className="card bg-shadow">
                                <div className="card-body p-0" id={"videos"}>
                                    <video key={video.signed_url} width="100%" height="220px" style={{ objectFit: 'cover' }} controls className={"card-img-top video-player " + (video.video_type === 'Time-Lapse Video' ? 'timelapse-video' : 'live-video')} video_container={"videos"}>
                                        <source src={video.signed_url} type="video/mp4" />
                                        <source src={video.signed_url} type="video/ogg" />
                                    </video>
                                </div>
                                <div className="card-footer border-0 bg-light">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <span className="text-app font-size-12 font-weight-700">
                                                Created By: {video.created_by}
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span className="text-app pull-right font-size-12 font-weight-300">
                                                <Moment format="MMM DD, YYYY HH:mm" tz={timezone}>{video.sec_timestamp * 1000}</Moment>
                                            </span>
                                        </div>
                                        <div className="col-md-6">
                                            <span className="text-app font-size-12 font-weight-300">
                                                {video.video_type}
                                            </span>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <span className="text-app font-size-12 font-weight-300">
                                                <button className="btn btn-sm btn-primary" onClick={() => shareVideo(video)}><i className="fa fa-share"></i></button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {videos && videos.length === 0 && <div className="col-12 mt-5 text-bold">No videos found ...</div>}
                </div>
            </div>
        </React.Fragment>
    );
}

export default VideosLibrary;